import { render, staticRenderFns } from "./TotalCalculator.vue?vue&type=template&id=2c4f77a4"
import script from "./TotalCalculator.vue?vue&type=script&lang=ts"
export * from "./TotalCalculator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports